module.exports = __webpack_public_path__ + "img/4.deb44517.png";